import { Id, LaravelResponse, keyToUrl, withIndexEndpoint } from "@dgs/core";
import axios from "axios";
import {
	AttachUserGroupsEventRequest,
	AttachUsersToEventRequest,
	EditEventUserResponsibilityRequest,
	EventUserResource,
	UserOptionResource,
} from "../types/user";
import { UserGroupOptionResource } from "../types/userGroup";

const baseEndPoints = (baseKey: string[]) => {
	const getAvailableUserGroupsKey = [...baseKey, "available-group-options"];
	const getAvailableUsersKey = [...baseKey, "available-options"];
	return {
		getAvailableUserGroups: (search: string, page: number, params?: Record<string, any>) =>
			axios.get<LaravelResponse<UserGroupOptionResource[]>>(keyToUrl(getAvailableUserGroupsKey), {
				params: { ...params, search, page },
			}),
		getAvailableUserGroupsKey,
		getAvailableUsers: (search: string, page: number, params?: Record<string, any>) =>
			axios.get<LaravelResponse<UserOptionResource[]>>(keyToUrl(getAvailableUsersKey), {
				params: { ...params, search, page },
			}),
		getAvailableUsersKey,
	};
};

export const createEventUserService = (id: Id) => {
	const baseKey = ["events", `${id}`, "users"];
	return {
		attachUserGroups: (values: AttachUserGroupsEventRequest) =>
			axios.post<LaravelResponse<void>>(keyToUrl([...baseKey, "attach-user-groups"]), values),
		attachUsers: (values: AttachUsersToEventRequest) =>
			axios.post<LaravelResponse<void>>(keyToUrl([...baseKey, "attach-users"]), values),
		detachUsers: (userIds: Id[]) => axios.post<LaravelResponse<void>>(keyToUrl([...baseKey, "detach"]), { userIds }),
		editResponsibility: (request: EditEventUserResponsibilityRequest) =>
			axios.post<LaravelResponse<void>>(keyToUrl([...baseKey, "edit-responsibility"]), request),
		...withIndexEndpoint<EventUserResource>(baseKey),
		...baseEndPoints(baseKey),
	};
};
